import { toast } from 'react-toastify';
import Bugsnag from '@bugsnag/js';

import { Pedido } from 'services/pedido';
import { Person } from 'services/client';
import 'firebase/analytics';
import firebase from 'firebase/compat/app';

export const validateEstoqueAndCustomer = (
  vehicleId: number,
  pessoaId: number,
  globalContext: any
): Promise<void> => {
  return new Promise<void>((resolve, reject) => {
    const bodyBudget = {
      veiculoEstoqueId: vehicleId,
      pessoaClienteId: pessoaId,
      escopoValidacao: 'ORCAMENTO_INICIAR',
    };

    Person.BudgetRequest(bodyBudget)
      .then((response) => {
        const dataBudget = response.data.data;

        switch (dataBudget.statusRetorno) {
          case 'CLIENTE_IMPEDIDO':
          case 'CLIENTE_DESENQUADRADO':
            toast.error('Cliente impedido ou desenquadrado');
            globalContext.setIsLoading(false);
            return reject();

          case 'VEICULO_DESENQUADRADO':
            toast.error('Veículo desenquadrado');
            globalContext.setIsLoading(false);
            return reject();

          case 'VEICULO_DESENQUADRADO_SITUACAO':
            toast.error('Situação do veículo inválida');
            globalContext.setIsLoading(false);
            return reject();

          default:
            return resolve();
        }
      })
      .catch((err) => {
        Bugsnag.notify(err);
        toast.error('Erro ao validar dados');
        reject(err);
      });
  });
};

export const postPedido = async (
  car: any,
  parcel: any,
  person: any,
  globalContext: any,
  handleCheckId?: (response: any) => void,
  avalistaId?: number
) => {
  if (!car || !parcel || !parcel.opcoes?.length) {
    toast.error('Carro ou parcelamento inválido.');
    globalContext.setIsLoading(false);
    return;
  }
  const analytics = firebase.analytics();
  const opcoes = parcel.opcoes[0];

  const pedido = {
    cancelarPedidoOriginal: false,
    pessoaClienteId: person.id,
    pessoaAvalistaId: avalistaId || undefined,
    criarReserva: false,
    opcaoSimulacaoFinanciamentoRequest: opcoes,
    observacao: '',
    origemPedido: 'PORTAL_LOJISTA',
    valorDespachante: car.valorDespachante,
    valorEntradaAVista: opcoes.valorEntradaAVista,
    valorSpm: 0,
    valorTotalVeiculo: car.preco,
    veiculoEstoqueId: car.veiculoId,
  };

  try {
    const event = await Pedido.PostPedido(pedido);
    const orderId = event.data.data.id;

    localStorage.setItem('PedidoId', orderId);
    globalContext.setIdPedido(orderId);
    globalContext.setPopUpNumPedido(orderId);

    analytics.logEvent('CK_PHASE_THREE', {
      idPedido: orderId,
      cliente: person.cpf,
      placa: car.plate,
    });

    const response = await Pedido.PostIDPedidoV2({
      pedidoId: orderId,
      versaoValidacao: '3',
      codPropostaAtualizar: null,
    });

    if (handleCheckId) {
      handleCheckId(response);
    }
  } catch (err) {
    Bugsnag.notify(err as Error);
    toast.error('Erro ao cadastrar o pedido.');
  } finally {
    globalContext.setIsLoading(false);
  }
};
